// extracted by css-extract-rspack-plugin
export default {"root":"V0ZI8L","create-discount-section":"BvyYXc","createDiscountSection":"BvyYXc","create-discount-caption":"MPSFBX","createDiscountCaption":"MPSFBX"};